import './theme/typography.css';
import './theme/editor.css';
import HRLThemeSettings from './components/HRLThemeSettings';
import installLoadables from './config/loadables';

const applyConfig = (config) => {
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: '',
      component: HRLThemeSettings,
    },
  ];
  installLoadables(config);
  return config;
};

export default applyConfig;
